import { HeaderBar } from "routes/schedule/compare/header-bar"
import { registerComparitor } from "routes/schedule/compare/register-comparitor"
import { RichTextDifference } from "routes/schedule/compare/rich-text-difference"
import { TextDifference } from "routes/schedule/compare/text-difference"

registerComparitor("title", () => (
    <HeaderBar label="Details">
        <TextDifference path="title" label="title" />
    </HeaderBar>
))

registerComparitor("intro.content", () => (
    <HeaderBar label="Introduction">
        <RichTextDifference path="intro.content" label="introduction" />
    </HeaderBar>
))

registerComparitor("intro.note", () => (
    <HeaderBar label="Introduction">
        <RichTextDifference path="intro.note" label="introductory notes" />
    </HeaderBar>
))
